module.exports = __webpack_public_path__ + "img/выгрузить список2.8883b8b9.svg";